var map = {
	"./bs_t-4_stitch_blk.png": 664233,
	"./bs_t-4_stitch_blu.png": 641079,
	"./bs_t-4_stitch_cml.png": 107452,
	"./bs_t-4_stitch_crk.png": 238442,
	"./bs_t-4_stitch_grn.png": 382443,
	"./bs_t-4_stitch_lgd.png": 930677,
	"./bs_t-4_stitch_lsl.png": 967241,
	"./bs_t-4_stitch_nvy.png": 341685,
	"./bs_t-4_stitch_orn.png": 294307,
	"./bs_t-4_stitch_pnk.png": 173681,
	"./bs_t-4_stitch_ppl.png": 607216,
	"./bs_t-4_stitch_red.png": 151033,
	"./bs_t-4_stitch_sax.png": 12860,
	"./bs_t-4_stitch_wht.png": 932231,
	"./bs_t-4_stitch_ylw.png": 484166
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39927;